export const MIN_STRING_LENGTH = 1;
export const MAX_FULL_NAME = 50

export const NAME_PATTERN = /^[a-zA-Z0-9@!#$^%&*()+=\-[\]\\‘';,./{}|“"`:<>?]+$/